
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-e-1-gz-6-r-yv-hvv-x-0-mi-pkxu-si.json") })
        }
      }, "path---projects-e-1-gz-6-r-yv-hvv-x-0-mi-pkxu-si");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---projects-e-1-gz-6-r-yv-hvv-x-0-mi-pkxu-si!./.cache/json/projects-e-1-gz-6-r-yv-hvv-x-0-mi-pkxu-si.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---projects-e-1-gz-6-r-yv-hvv-x-0-mi-pkxu-si!./.cache/json/projects-e-1-gz-6-r-yv-hvv-x-0-mi-pkxu-si.json
// module chunks = 15178676390636814000